import APIUtils from '@livongo/utilities/system/api';
import CommonUtils from '@/utils/common-utils';
import OneAppUserAPI from '@/user/user-oneapp-api';
import {IS_BIA_MOCK_ENABLED, SERVICE_AUTH_GATEWAY_URL} from '@/config';
import {
    MOCK_BIA_TASK,
    MOCK_BIA_TASK_ID,
    MOCK_BIA_TASK_DETAIL,
} from './mock-data';

const NextStepsAPI = {
    getTasks({locale, viewAll = false, brandCode}) {
        return APIUtils.get(
            `${SERVICE_AUTH_GATEWAY_URL}/service-journey-guidance/v1/users/me/next-steps/tasks?localTimezone=${CommonUtils.getTimezone()}&viewAllTasks=${viewAll}&brandCode=${brandCode}`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${OneAppUserAPI.getTdocAuthToken()}`,
                    'Content-Type': 'application/json',
                    'Accept-Language': locale,
                },
            }
        )
            .then(response => {
                // BE returns { userNextStepsTasks: { tasks: [...], nextStepsTitle, totalTasks, ... } }
                // Callers expect the full response.data object shape to be preserved.
                const responseData = response.data || {};
                const tasks = responseData?.userNextStepsTasks?.tasks || [];

                // TODO: [TDT-34] REMOVE the mock injection block below once BE sends
                // START_TRACKING_BODY_COMPOSITION in this API response.
                // When BE is ready, revert this .then() to simply: .then(response => response.data)
                if (IS_BIA_MOCK_ENABLED) {
                    const hasBiaTask = tasks.some(
                        task => task.code === 'START_TRACKING_BODY_COMPOSITION'
                    );

                    if (!hasBiaTask) {
                        return {
                            ...responseData,
                            userNextStepsTasks: {
                                ...responseData.userNextStepsTasks,
                                tasks: [...tasks, MOCK_BIA_TASK],
                            },
                        };
                    }
                }

                return responseData;
            })
            .catch(error => {
                throw error;
            });
    },

    getTaskDetailById({taskId, locale}) {
        // TODO: [TDT-34] REMOVE this mock intercept once BE supports this task detail endpoint.
        // When BE is ready, remove the if-block below.
        if (IS_BIA_MOCK_ENABLED && Number(taskId) === MOCK_BIA_TASK_ID) {
            return Promise.resolve(MOCK_BIA_TASK_DETAIL);
        }

        return APIUtils.get(
            `${SERVICE_AUTH_GATEWAY_URL}/service-journey-guidance/v1/users/me/tasks/${taskId}`,
            null,
            {
                headers: {
                    Authorization: `Bearer ${OneAppUserAPI.getTdocAuthToken()}`,
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                    'Accept-Language': locale,
                },
            }
        ).then(response => response.data);
    },

    submitTaskById({taskId, status, locale}) {
        const data = {
            status,
        };

        return APIUtils.put(
            `${SERVICE_AUTH_GATEWAY_URL}/service-journey-guidance/v1/users/me/tasks/${taskId}?localTimezone=${CommonUtils.getTimezone()}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${OneAppUserAPI.getTdocAuthToken()}`,
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                    'Accept-Language': locale,
                },
            }
        ).then(response => response.data);
    },

    updateTaskByOption({taskId, preferences, locale}) {
        const payload = {
            preferences,
        };

        return APIUtils.put(
            `${SERVICE_AUTH_GATEWAY_URL}/service-journey-guidance/v1/users/me/tasks/${taskId}?localTimezone=${CommonUtils.getTimezone()}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${OneAppUserAPI.getTdocAuthToken()}`,
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                    'Accept-Language': locale,
                },
            }
        ).then(response => response.data);
    },
};

export default NextStepsAPI;
